import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import {
   Card,
   CardTitle
} from 'reactstrap';
import {
   allAssignStudentsList,
   roleAcademys,
   allStudents,
   contractDetailCount
} from 'Actions';

import StudentDashboard from './studentdashboard';
import { border } from '@mui/system';
import { borderColor } from '@mui/system';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';


class dashboard extends Component {

   constructor(props) {

      super(props);
      this.state = {
         academydiv: false,
         sudentdiv: false,
         stdlist: 'Students List',
         selStudent: 0,
         stddashboarddiv: false,
         searchQuery: '',
         studentname:'',
      };

      this.onBackSection = this.onBackSection.bind(this);
   }

   componentDidMount() {
      const role = localStorage.getItem('user_role');
      if (role == 1 || role == 5) {
         this.props.roleAcademys();
         this.setState({ academydiv: true });
      } else if (role == 2) {
         var id = '';
         this.props.allAssignStudentsList(id)
         this.setState({ sudentdiv: true });
      } else if (role == 13) {
         this.props.contractDetailCount();
      }
   }

   academyselect(e, val) {
      e.preventDefault();
      var name = val.aad_name + ' - Students List';
      var id = val.aadID;
      this.props.allAssignStudentsList(id).then((data) => {

         this.setState({
            stdlist: name,
            academydiv: false,
            sudentdiv: true,
         });

      });
   }

   onBackSection(e, id) {
      e.preventDefault();
      if (id == 1) {
         this.setState({
            academydiv: true,
            sudentdiv: false,
         });
      } else if (id == 2) {
         this.setState({
            academydiv: false,
            stddashboarddiv: false,
            sudentdiv: true,
         });
      }
   }

   studentselect(e, val, name) {
      e.preventDefault();      
      var id = val.uudID;
      this.setState({
         selStudent: id,
         studentname:name.toUpperCase()
      });
      this.setState({
         academydiv: false,
         sudentdiv: false,
         stddashboarddiv: true,
      });
   }

   handleSearchInputChange = (e) => {
      this.setState({ searchQuery: e.target.value });
   };

   getCurrentMonth(){
      const date = new Date();
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[date.getMonth()];
   };

   getNextMonth(){
      const date = new Date();
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const nextMonthIndex = (date.getMonth() + 1) % 12;
      return monthNames[nextMonthIndex];
   };


   render() {
      const { match } = this.props;
      const { studentlists, academylists, academystudentslist, contractdashboardcount, loading } = this.props;     
      const usrrole = localStorage.getItem('user_role');

      const { searchQuery } = this.state;
      const filteredStudents = academystudentslist.filter(
         (stdlst) =>
            stdlst.student.toLowerCase().includes(searchQuery.toLowerCase())
      );
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Dashboard | {AppConfig.appTitle}</title>
               <meta name="description" content="Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.saas" />} match={match} />

            {this.state.academydiv &&
               <div className="row">
                  <div className="col-md-12">
                     <h2 className="text-center">Academy List</h2>
                  </div>
                {academylists.map((acdylst) => (
  <button
    key={acdylst.aadID}
    className="mr-3 mb-3 btn btn-outline-info txtchange"
    onClick={(e) => this.academyselect(e, acdylst)}
  >
    {acdylst.aad_name}
  </button>
))}

               </div>
            }

            {this.state.sudentdiv &&
               <div className="row">
                  <div className="col-md-12">
                     <h2 className="text-center">{this.state.stdlist}</h2>
                  </div>
                  <div className="col-md-12">
                     {usrrole != 2 ? <div className="float-right">
                        <button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={e => this.onBackSection(e, 1)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button>
                     </div>
                        : ""}
                  </div>
                  <div className="col-md-12 mb-3" >
                     <input
                        type="text"
                        className="form-control"
                        placeholder="Search student..."
                        value={searchQuery}
                        style={{ width: "30%" }}
                        onChange={this.handleSearchInputChange}
                     />
                  </div>
                  {filteredStudents.map((stdlst) => (

                     <div className="col-sm-6 col-md-2 mb-30 stdbox">
                        <Card body outline onClick={e => this.studentselect(e, stdlst, stdlst.student)} id="stdboxinner">
                           <div><h3 className="text-center" style={{ color: "#505971", marginBottom: 0 }}>{stdlst.student}</h3></div>
                        </Card>
                     </div>

                  ))}
               </div>
            }
              
            { usrrole==13 ?
               <div className="row">
                     <div class="col-sm-12 col-md-3 mb-30">
                        <div class="card card-body" style={{borderColor:"#5d92f4"}}>
                           <h1 className="text-center">STUDENTS</h1>
                           <h2 className="text-center"><strong>{contractdashboardcount.studentlist}</strong></h2>
                        </div>
                     </div>
                     <div class="col-sm-12 col-md-3 mb-30">
                        <div class="card card-body" style={{borderColor:"#ffb70f"}}>
                           <h1 className="text-center">INSTALMENT DUE</h1>
                           <h2 className="text-center">{this.getCurrentMonth()} :<strong> {contractdashboardcount.currinstalment}</strong></h2>
                           <h2 className="text-center">{this.getNextMonth()} : <strong>{contractdashboardcount.previnstalment}</strong></h2>
                        </div>
                     </div>
                     <div class="col-sm-12 col-md-3 mb-30">
                        <div class="card card-body" style={{borderColor:"#00d0bd"}}>
                           <h1 className="text-center">RENEWALS DUE</h1>
                           <h2 className="text-center">{this.getCurrentMonth()} :<strong> {contractdashboardcount.currenewal}</strong></h2>
                           <h2 className="text-center">{this.getNextMonth()} :<strong> {contractdashboardcount.prevrenewal}</strong></h2>
                        </div>
                     </div>
                     <div class="col-sm-12 col-md-3 mb-30">
                        <div class="card card-body" style={{borderColor:"#ff3739"}}>
                           <h2 className="text-center">PENDING CONTRACT</h2>
                           <h1 className="text-center"><strong>{contractdashboardcount.pending}</strong></h1>
                        </div>
                     </div>
               </div>
            :""}
            {this.state.stddashboarddiv &&

               <StudentDashboard data={this.state} onClick={this.onBackSection} />

            }


         </div>
      )
   }
}

const mapStateToProps = ({ academy, mostlyused }) => {
   const { academylists } = academy;
   const { studentlists, academystudentslist, contractdashboardcount, loading } = mostlyused;
   return { studentlists, academylists, academystudentslist, contractdashboardcount, loading };
}

export default connect(mapStateToProps, {
   allAssignStudentsList,
   roleAcademys,
   allStudents,
   contractDetailCount
})(dashboard); 